/* eslint-disable react-hooks/exhaustive-deps */
import { Table, Select, DatePicker, Pagination, Switch, Spin } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import { useEffect, useState } from "react";

import { showErrorNotification } from "../../../../utils/notification";
import { clamp } from "../../../../utils/responsiveHelpers";

const PAGE_SIZE = 100;
const SORT_OPTIONS = [
  { label: "Total verified Count Desc", value: "totalVerifiedSolvedCountDesc" },
  { label: "Total verified Count Asc", value: "totalVerifiedSolvedCountAsc" },
  { label: "Total Visit Count Desc", value: "totalVisitCountDesc" },
  { label: "Total Visit Count Asc", value: "totalVisitCountAsc" }
];

const CPSheetUserAnalyticsDash = ({ ROOT_URL }) => {
  const BASE_BACKEND_URL = "admin/cp-sheet/analytics/user";

  const currentDate = new Date();
  const oneMonthAgo = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() - 1,
    currentDate.getDate()
  );

  // Filter States.
  const [filter, setFilter] = useState({
    startDate: oneMonthAgo,
    endDate: currentDate,
    page: 1,
    verifiedUserOnly: true,
    sortBy: "NA"
  });
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalUsers, setTotalUsers] = useState(1);

  // Page states.
  const [usersData, setUsersData] = useState([]);

  // const csvLinkRef = useRef(null);
  // const [usersCSVData, setUsersCSVData] = useState([]);

  const fetchUserLevelAnalytics = () => {
    setIsLoading(true);
    axios
      .get(`${ROOT_URL}/${BASE_BACKEND_URL}/analytics`, {
        params: {
          filter
        }
      })
      .then((res) => {
        const { usersTableData, totalUsers } = res.data;
        setTotalUsers(totalUsers);
        setUsersData(usersTableData);
      })
      .catch((err) => {
        showErrorNotification(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  // const handleDownloadCsv = () => {
  //   setIsLoading(true);
  //   axios
  //     .get(`${ROOT_URL}/${BASE_BACKEND_URL}/csv-download-data`, {
  //       params: {
  //         filter
  //       }
  //     })
  //     .then((res) => {
  //       const { usersTableData } = res.data;
  //       setUsersCSVData(usersTableData);
  //     })
  //     .catch((err) => {
  //       showErrorNotification(err);
  //     })
  //     .finally(() => {
  //       setIsLoading(false);
  //     });
  // };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    setFilter((prevFilter) => ({
      ...prevFilter,
      page
    }));
  };

  useEffect(() => {
    fetchUserLevelAnalytics();
  }, [filter]);

  // useEffect(() => {
  //   if (usersCSVData.length > 0 && csvLinkRef.current) {
  //     csvLinkRef.current.link.click();
  //   }
  // }, [usersCSVData]);

  const columns = [
    {
      title: "S. No",
      dataIndex: "index",
      key: "index"
    },
    {
      title: "Name",
      dataIndex: "Name",
      key: "Name"
    },
    {
      title: "Email",
      dataIndex: "Email",
      key: "Email"
    },
    {
      title: "CF Handle",
      dataIndex: "CF Handle",
      key: "CF Handle"
    },
    {
      title: "CF Handle Verified",
      dataIndex: "CF Handle Verified",
      key: "CF Handle Verified",
      sorter: (a, b) => {
        if (
          typeof a["CF Handle Verified"] === "string" &&
          typeof b["CF Handle Verified"] === "string"
        ) {
          return a["CF Handle Verified"]?.localeCompare(b["CF Handle Verified"]) | 0;
        }
        // Fallback comparison if not string (handle the case if one or both values are not strings)
        return 0;
      }
    },
    {
      title: "Institution",
      dataIndex: "Institution Name",
      key: "Institution Name"
    },
    {
      title: "Visit Count",
      dataIndex: "Visit Count",
      key: "Visit Count",
      sorter: (a, b) => a["Visit Count"] - b["Visit Count"]
    },
    {
      title: "800",
      dataIndex: "800",
      key: "800",
      sorter: (a, b) => a["800"] - b["800"]
    },
    {
      title: "900",
      dataIndex: "900",
      key: "900",
      sorter: (a, b) => a["900"] - b["900"]
    },
    {
      title: "1000",
      dataIndex: "1000",
      key: "1000",
      sorter: (a, b) => a["1000"] - b["1000"]
    },
    {
      title: "1100",
      dataIndex: "1100",
      key: "1100",
      sorter: (a, b) => a["1100"] - b["1100"]
    },
    {
      title: "1200",
      dataIndex: "1200",
      key: "1200",
      sorter: (a, b) => a["1200"] - b["1200"]
    },
    {
      title: "1300",
      dataIndex: "1300",
      key: "1300",
      sorter: (a, b) => a["1300"] - b["1300"]
    },
    {
      title: "1400",
      dataIndex: "1400",
      key: "1400",
      sorter: (a, b) => a["1400"] - b["1400"]
    },
    {
      title: "1500",
      dataIndex: "1500",
      key: "1500",
      sorter: (a, b) => a["1500"] - b["1500"]
    },
    {
      title: "1600",
      dataIndex: "1600",
      key: "1600",
      sorter: (a, b) => a["1600"] - b["1600"]
    },
    {
      title: "1700",
      dataIndex: "1700",
      key: "1700",
      sorter: (a, b) => a["1700"] - b["1700"]
    },
    {
      title: "1800",
      dataIndex: "1800",
      key: "1800",
      sorter: (a, b) => a["1800"] - b["1800"]
    },
    {
      title: "1900",
      dataIndex: "1900",
      key: "1900",
      sorter: (a, b) => a["1900"] - b["1900"]
    },
    {
      title: "Total Count",
      dataIndex: "Total Solved Count",
      key: "Total Solved Count",
      sorter: (a, b) => a["Total Solved Count"] - b["Total Solved Count"]
    }
  ];

  return (
    <div
      style={{
        marginTop: "20px",
        marginLeft: clamp(12, 30),
        marginRight: clamp(12, 30)
      }}
    >
      <div
        style={{
          marginBottom: "10px",
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          gap: "5px",
          minHeight: "30px"
        }}
      >
        Date filter:{" "}
        <DatePicker.RangePicker
          style={{ width: "20%" }}
          value={
            filter.startDate && filter.endDate
              ? [dayjs(filter.startDate), dayjs(filter.endDate)]
              : []
          }
          onChange={(dates) => {
            if (dates) {
              setFilter((prevFilter) => ({
                ...prevFilter,
                startDate: dates[0].startOf("day").toDate(),
                endDate: dates[1].endOf("day").toDate()
              }));
            } else {
              setFilter((prevFilter) => ({
                ...prevFilter,
                startDate: null,
                endDate: null
              }));
            }
          }}
        />
        Sort By:{" "}
        <Select
          placeholder="Select an option"
          defaultValue="NA"
          style={{ width: "min(200px, 100%)", marginBottom: 10 }}
          allowClear
          onClear={() => {
            setFilter((prevFilter) => ({
              ...prevFilter,
              sortBy: undefined
            }));
          }}
          onChange={(value) => {
            setFilter((prevFilter) => ({
              ...prevFilter,
              sortBy: value
            }));
          }}
        >
          {(SORT_OPTIONS || []).map((option) => (
            <Select.Option value={option.value} key={option.value}>
              {option.label}
            </Select.Option>
          ))}
        </Select>
        CF Verified Only{" "}
        <Switch
          checked={filter?.verifiedUserOnly || false}
          onChange={(checked) => {
            setFilter((prevFilter) => ({
              ...prevFilter,
              verifiedUserOnly: checked
            }));
          }}
        />
        <>
          {/* <CSVLink
            asyncOnClick={true}
            data={usersCSVData || []}
            ref={csvLinkRef}
            filename={"CP_SHEET_USER_DATA.csv"}
          />
          <Button
            type="primary"
            onClick={() => {
              handleDownloadCsv();
            }}
          >
            Download CSV
          </Button> */}
        </>
      </div>
      <h3>Solved Data is available from 9th Feb only.</h3>
      <p>
        <li>
          Only values in the <b>Visit Count</b> table are controlled by the <b>date filter.</b>
        </li>
        <li>
          Total solved count and rating-wise solved count is the realtime data of the users and same
          is visible for <b>CF Verified</b> users on the leaderboard.{" "}
          <b>Non CF Verified users are not shown on the leaderboard</b>
        </li>
      </p>
      <Spin spinning={isLoading} size="large" tip="Loading mammoth amount of data...">
        <Table
          scroll={{ x: 1000 }}
          dataSource={usersData}
          columns={columns}
          bordered
          pagination={false}
        />
        <Pagination
          total={totalUsers}
          showSizeChanger={false}
          showQuickJumper={false}
          pageSize={PAGE_SIZE}
          current={currentPage}
          onChange={handlePageChange}
        />
      </Spin>
    </div>
  );
};

export default CPSheetUserAnalyticsDash;
